import { render, staticRenderFns } from "./MainHeaderNote.vue?vue&type=template&id=4d6b05a6&scoped=true&lang=pug&"
import script from "./MainHeaderNote.vue?vue&type=script&lang=js&"
export * from "./MainHeaderNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b05a6",
  null
  
)

export default component.exports